import { MouseEvent, MouseEventHandler, ReactNode, type FC, memo } from 'react';
import IconTab from '@bridebook/ui/src/components/bbcommon/tabs/icon-tab';
import { NavigationDestination } from '@bridebook/web/lib/analyticsTypes';
import { hapticFeedbackLight } from '@bridebook/web/lib/mobile-app/utils/haptic-feedback-light';
import styles from './bottom-tab-mobile.style';
import { useSelector } from '@bridebook/web/lib/utils';
import { getServerPage, getPathname } from '@bridebook/web/lib/app/selectors';

interface IBottomTabMobileProps {
  bottomTab: BottomTab;
}

export interface BottomTab {
  id: string;
  title: string;
  url?: string;
  destination: NavigationDestination;
  icon: JSX.Element;
  iconActive: JSX.Element;
  onClick(e: MouseEvent<ReactNode>, bottomTab: BottomTab): void;
  isActive?: (args: { pathname: string; serverPage: string }) => boolean;
}

const BottomTabMobile: FC<IBottomTabMobileProps> = ({ bottomTab }) => {
  const serverPage = useSelector(getServerPage);
  const pathname = useSelector(getPathname);

  const isActive = Boolean(
    bottomTab.isActive?.({ pathname, serverPage }) ||
      (bottomTab.url && pathname.includes(bottomTab.url)),
  );

  const handleClick: MouseEventHandler<ReactNode> = (e) => {
    e.preventDefault();
    bottomTab.onClick(e, bottomTab);
    hapticFeedbackLight();
  };

  return (
    <IconTab
      style={styles.iconTabWrap}
      onClick={handleClick}
      icon={bottomTab.icon}
      iconActive={bottomTab.iconActive}
      isActive={isActive}>
      {bottomTab.title}
    </IconTab>
  );
};

export default memo(BottomTabMobile);
